import { Navigate } from 'react-router-dom';

import { setLocalEntrySource } from '@/entities/entrySource';
import { useCognitoCheckUser } from '@/entities/user/currentUser';

import { PATHS } from '@/shared/constants/routes/paths';
import { Loader } from '@/shared/ui/Loader';

export const RecordingEntryCapture = () => {
  const { data, isLoading } = useCognitoCheckUser();
  const isAuthenticated = Boolean(data?.isAuthorized);

  if (isLoading) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    setLocalEntrySource('recording');
  }

  return (
    <>
      <Loader />
      <Navigate to={PATHS.homepage} replace />
    </>
  );
};
